import * as React from 'react';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import { isFalsy } from '../../../../utils/common';
import DollarIcon from '../../../geebee/icons/course-details-page/DollarIcon';
export var UspLabelImageMapper = {
    HIGH_OFFER_RATE: undefined,
    QUICKEST_OFFER_TAT: 'fi fi-rr-time-fast ',
    GB_APP_FEE_WAIVER: 'fi fi-rr-briefcase text',
    HIGH_RANKING_INSTITUTE: 'fi fi-rr-ranking-star',
    PLACEMENT_SUPPORT: 'fi fi-rr-briefcase text',
    AFFORDABILITY: undefined,
    MOI_ACCEPTED: 'fi fi-rs-assept-document',
    POPULAR_AMONG_GEEBEE: 'fi fi-rr-circle-star',
    STUDENT_FAVOURITE_UNIVERSITY_FOR_APPLICATIONS: 'fi fi-sr-heart text-error-600',
    HIGHEST_ENROLLMENT_RATE: 'fi fi-sr-plane-departure text-primary-700',
    CONDITIONAL_OFFER_GIVEN: undefined,
    HIGHEST_COMMISSION_INSTITUTE: undefined,
    HIGHEST_COMMISSION_IN_COUNTRY: undefined,
    SPOUSAL_VISA: 'fi fi-rr-plane-departure',
    NO_APP_FEE: 'fi fi-rr-no-fee'
};
export var getUspHelperIcon = function (uspKey, isUspSelected) {
    if (uspKey === 'AFFORDABILITY') {
        return React.createElement(DollarIcon, { fill: isUspSelected ? '#3430B1' : '#686868' });
    }
    if (uspKey === 'HIGH_OFFER_RATE') {
        return (React.createElement(EmojiEventsOutlinedIcon, { className: "w-4 h-4 flex items-center ".concat(isUspSelected ? 'text-[#3430B1]' : 'text-[#686868]') }));
    }
    return null;
};
export var transformUspsInfoForCourseFinder = function (usps) {
    if (isFalsy(usps))
        return [];
    var transformed = usps === null || usps === void 0 ? void 0 : usps.map(function (data) {
        return {
            label: data === null || data === void 0 ? void 0 : data.uspLabel,
            tooltipContent: data === null || data === void 0 ? void 0 : data.uspValue,
            helperIcon: UspLabelImageMapper[data === null || data === void 0 ? void 0 : data.uspName] ? (React.createElement("i", { className: " ".concat(UspLabelImageMapper[data === null || data === void 0 ? void 0 : data.uspName], " lfc-flex lfc-items-center") })) : null,
            key: data === null || data === void 0 ? void 0 : data.uspName
        };
    });
    return transformed;
};
//# sourceMappingURL=helpers.js.map